import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { NEXTJS_DECENTRALIZE_PAGE_DATA_250303 } from "@faire/web-api--source/indigofair/settings/NEXTJS_DECENTRALIZE_PAGE_DATA_250303";

export const useSettingDecentralizePageData = (): boolean =>
  useSetting(NEXTJS_DECENTRALIZE_PAGE_DATA_250303, false);

export const useAssignSettingDecentralizePageData = () =>
  useAssignSetting(NEXTJS_DECENTRALIZE_PAGE_DATA_250303);
